import { render, staticRenderFns } from "./BaseCard.vue?vue&type=template&id=6dbcad69&scoped=true&"
import script from "./BaseCard.vue?vue&type=script&lang=js&"
export * from "./BaseCard.vue?vue&type=script&lang=js&"
import style0 from "./BaseCard.vue?vue&type=style&index=0&id=6dbcad69&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6dbcad69",
  null
  
)

export default component.exports